import { ReactNode } from "react";
import styles from "./InvitesPage.module.css";

export interface PillSpec<T extends string> {
  id: T;
  label: string;
  count: number;
}

interface Props<T extends string> {
  pills: PillSpec<T>[];
  active: T;
  onChange: (id: T) => void;
  ariaLabel?: string;
}

/**
 * Pill-bar filter — matches mockup `invites-list.html` L94-L111 / L299-L305.
 * Each pill shows a label + monospace count badge; the active pill gets the
 * surface-coloured background and accent-tinted count badge.
 */
export function StatusPills<T extends string>({
  pills,
  active,
  onChange,
  ariaLabel,
}: Props<T>): ReactNode {
  return (
    <div
      className={styles.pillBar}
      role="tablist"
      aria-label={ariaLabel ?? "Status filter"}
    >
      {pills.map((p) => {
        const isActive = p.id === active;
        return (
          <button
            key={p.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`${styles.pill} ${isActive ? styles.pillActive : ""}`}
            onClick={() => onChange(p.id)}
          >
            <span>{p.label}</span>
            <span className={styles.pillCount}>{p.count}</span>
          </button>
        );
      })}
    </div>
  );
}
